import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { ListSchedule } from "models/list-schedule";
import { Fragment, FunctionComponent, useState } from "react";
import AddScheduleModal from "./add-schedule-modal";
import { timestamp } from "lib/date";
import { parse } from "lib/locale";
import { useLocale } from "stores/hooks/locale";
import { showError, showSuccess } from "lib/notification";
import { adminDoDeleteListSchedule } from "services/admin/list-schedule";
import EditScheduleModal from "./edit-schedule-modal";
import { List } from "models/list";
import { useTranslate } from "stores/hooks/translation";

interface ScheduledTableProps {
  list: List;
  schedules: ListSchedule[];
  onUpdate: () => Promise<void>;
}

const ScheduledTable: FunctionComponent<ScheduledTableProps> = ({
  list,
  schedules,
  onUpdate,
}) => {
  const locale = useLocale();
  const translate = useTranslate();
  const [addModal, toggleAddModal] = useState(false);
  const [editModal, toggleEditModal] = useState<ListSchedule | undefined>(
    undefined,
  );

  const columns: ColumnInterface[] = [
    {
      key: "timestamp",
      header: "Lähetysaika",
      render: (schedule: ListSchedule) => timestamp(schedule.send_at),
      width: 200,
    },
    {
      key: "recipients",
      header: "Vastaanottajat",
      render: (schedule: ListSchedule) =>
        translate(`email_filter_${schedule.recipients}`),
      width: 200,
    },
    {
      key: "subject",
      header: "Otsikko",
      render: (schedule: ListSchedule) => parse(schedule.subject, locale),
    },
  ];

  const handleEdit = async (listSchedule: ListSchedule) => {
    toggleEditModal(listSchedule);
  };

  const handleDelete = async (listSchedule: ListSchedule) => {
    try {
      // send delete request
      await adminDoDeleteListSchedule(list, listSchedule.uuid);

      // update list and notify
      onUpdate();
      showSuccess("Ajastettu kutsu poistettu.");
    } catch (err) {
      showError("Ajastetun kutsun poisto epäonnistui.");
    }
  };

  return (
    <Fragment>
      <Table
        name={`list-${list.uuid}-scheduled`}
        columns={columns}
        data={schedules}
        adder={{
          text: "Uusi kutsu tai ajastettu kutsu",
          onClick: async () => toggleAddModal(true),
        }}
        editers={[{ onClick: handleEdit }]}
        deleter={{ onClick: handleDelete }}
      />
      {addModal && (
        <AddScheduleModal
          list={list}
          onUpdate={onUpdate}
          onClose={async () => toggleAddModal(false)}
        />
      )}
      {editModal && (
        <EditScheduleModal
          list={list}
          listSchedule={editModal}
          onUpdate={onUpdate}
          onClose={async () => toggleEditModal(undefined)}
        />
      )}
    </Fragment>
  );
};

export default ScheduledTable;
